export default "__VITE_ASSET__6KQvMa_P__"